module.exports = __webpack_public_path__ + "media/images/clients/epay-7f4f3ed6717d2d96434e2ba50b634274.png";